import { PracticeInfo, CustomerInfo, MemberDetail } from '.';

export class SignUpMemberCommand {
  userDetail: MemberDetail = new MemberDetail();
  practiceInfo: PracticeInfo = new PracticeInfo();
  doingBusinessAs: CustomerInfo = new CustomerInfo();
}

export class SignInMemberCommand {
  email: string = '';
  password: string = '';
  practiceId: number = 0;
  recaptchaToken :string = '';
}

export class ResetPasswordMemberCommand {
  passwordResetToken: string = '';
  newPassword: string = '';
  confPassword: string = '';
  firstName?: string = '';
  lastName?: string = '';
}

export class CheckEmailExistMemberCommand {
  email: string = '';
}

export class AutoSignInMemberCommand {
  id: number = 0;
  practiceId: number = 0;
}